class ReviewsResource {
  findAll(params = {}) {
    return $.ajax({
      method: "GET",
      url: `${st.GLOBALS.BACKEND_URL}reviews.json`,
      data: params,
      headers: st.resources.defaults.headers,
    });
  }
}

st.resources = st.resources || {}
const resource = st.resources.reviews = new ReviewsResource()
export default resource



// WEBPACK FOOTER //
// ./app/webpack/frontend/common/resources/ReviewsResource.js